import React, { PropsWithChildren, useMemo } from 'react';

import clsx from 'clsx';

import { ColorName, colors } from '@styles';

import classes from './loader.module.scss';

type RawProps = {
  className?: string;
  loading?: boolean;
  button?: boolean;
  color?: ColorName;
  overlayColor?: ColorName;
  size?: 'large';
  style?: React.CSSProperties;
};

type Props = PropsWithChildren<RawProps>;

export const Loader = ({
  className,
  children,
  loading,
  color,
  overlayColor,
  button,
  size,
  style,
}: Props) => {
  const spinner = useMemo(
    () => (
      <div
        className={clsx(
          classes.spinner__wrapper,
          button && classes.spinner__wrapperButton,
          size === 'large' && classes.large,
        )}
      >
        <div className={classes.spinner__outer}>
          <div
            className={classes.spinner__inner}
            style={{
              borderColor: color ? colors[color].hex() : colors.fiord.hex(),
            }}
          />
        </div>
      </div>
    ),
    [button, color],
  );

  if (!children) {
    return (
      <div
        className={clsx(classes.spinner__standaloneWrapper, className)}
        style={style}
      >
        {spinner}
      </div>
    );
  }

  const overlayBackgroundColor = overlayColor
    ? colors[overlayColor]
    : colors.white;

  return (
    <div
      className={clsx(classes.spinner__childrenWrapper, className)}
      style={style}
    >
      {children}
      <div
        className={clsx(
          classes.spinner__childrenWrapperOverlay,
          loading && classes['spinner__childrenWrapperOverlay--visible'],
        )}
        style={{
          backgroundColor: overlayBackgroundColor.alpha(0.5).toString(),
        }}
      >
        {spinner}
      </div>
    </div>
  );
};
